// This file was automatically generated from uiwidget.TabbedNav.html.
// Please don't edit this file by hand.

goog.provide('el8.template.uiwidget.TabbedNav');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.TabbedNav.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ul class="', soy.$$escapeHtml(opt_data.tabSectionClass), ' ebs-nav ', (opt_data.tabSectionClass == 'el8VerticalTabSection') ? 'ebs-nav-pills ebs-nav-stacked' : 'ebs-nav-tabs', ' ', (opt_data.additionalClass) ? soy.$$escapeHtml(opt_data.additionalClass) : '', '"></ul>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.TabbedNav.tab = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="tabbed-nav-item ', soy.$$escapeHtml(opt_data.tabItemClass), '" data-tab="', soy.$$escapeHtml(opt_data.name), '">', (opt_data.isSectionHeader) ? '<hr/>' : '', '<a ', (opt_data.keyboardFriendly) ? 'tabindex="0"' : '', ' ', (opt_data.testId) ? 'data-testid="' + soy.$$escapeHtml(opt_data.testId) + '"' : '', '>', soy.$$escapeHtml(opt_data.title), (opt_data.hasCount) ? '<span class="tabbed-nav-count ' + soy.$$escapeHtml(opt_data.tabCountClass) + '" data-tab="' + soy.$$escapeHtml(opt_data.name) + '"></span>' : '', '</a></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.TabbedNav.disabledTab = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="', soy.$$escapeHtml(opt_data.tabItemDisabledClass), ' " data-tab="', soy.$$escapeHtml(opt_data.name), '">', (opt_data.isSectionHeader) ? '<hr/>' : '', '<a ', (opt_data.keyboardFriendly) ? 'tabindex="0"' : '', ' ', (opt_data.testId) ? 'data-testid="' + soy.$$escapeHtml(opt_data.testId) + '"' : '', '>', soy.$$escapeHtml(opt_data.title), (opt_data.hasCount) ? '<span class="tabbed-nav-count ' + soy.$$escapeHtml(opt_data.tabCountClass) + '" data-tab="' + soy.$$escapeHtml(opt_data.name) + '"></span>' : '', '</a></li>');
  if (!opt_sb) return output.toString();
};
